import { Reveal, SectionHeader } from "./Reveal";

const Intro = () => (
  <section id="intro" data-testid="intro-section" className="relative py-28 md:py-40">
    <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <SectionHeader
          index={1}
          overline="Who We Are"
          title={<>Technology Should<br />Work as <span className="text-smipl-orange">One.</span></>}
        />
        <Reveal delay={0.1}>
          <p className="text-slate-400 text-base md:text-lg leading-relaxed">
            <span className="text-white font-semibold">Swapna Meditech Industries Pvt. Ltd. (SMIPL)</span> is a
            system integration company established in <span className="text-smipl-orange font-semibold">2022</span>,
            built on a simple conviction — enterprise technology delivers its real value only when every layer
            works together.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-slate-400 text-base md:text-lg leading-relaxed">
            We bring networking, cybersecurity, collaboration, compute and sourcing under one accountable roof —
            from the first requirement workshop to years of dependable support.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-wrap gap-3">
            {["System Integration", "Established 2022", "ISO 9001:2015 Certified", "Multi-domain Engineering"].map((t) => (
              <span key={t} className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-mono tracking-wider text-slate-300">
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="relative">
        <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50">
          <img
            src="https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Enterprise data centre infrastructure"
            className="w-full h-[420px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/20 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-smipl-orange">One accountable partner</p>
            <p className="mt-2 text-white font-display text-xl font-semibold">From requirement to reality — and beyond.</p>
          </div>
        </div>
        <div className="absolute -top-5 -right-5 h-24 w-24 rounded-full border border-smipl-orange/30 pointer-events-none hidden md:block" />
      </Reveal>
    </div>
  </section>
);

export default Intro;
